import { getConfigurationIds, isStandalone } from '../../modules/configuration/selectors';
import { DistributorThunkAction } from '../../types';

export const checkGTMBlocked =
    (containerId: string | null): DistributorThunkAction =>
    (_dispatch, getState, { environmentService, loggerService }) => {
        if (containerId == null) {
            // we care only about configuration containerId
            return;
        }
        const windowGoogleTagManager = environmentService.get('google_tag_manager');
        const isBlocked = windowGoogleTagManager?.[containerId] == null;
        const configurationIds = getConfigurationIds(getState());
        const standalone = isStandalone(getState());

        loggerService.log('gtm-blocked-via-ad-blocker', 'AdBlocker prevented GTM initialization in the context', {
            isBlocked,
            configurationIds,
            containerId,
            isStandalone: standalone,
        });
    };
